<table class="basicTable" style="min-width: 100%;">
  <thead>
    <tr><th colspan="5" class="colheader">SQL Server Connections</th></tr>
  </thead>
  <tbody>
    <tr *ngIf="!databaseId"><td colspan="5"><em>Save the database before adding connections.</em></td></tr>
    <ng-container *ngIf="databaseId">
      <tr>
        <td colspan="5">
          <div class="hbox lightly-padded button-bar" style="flex-wrap: nowrap;">
            <micro-select-pagination *ngIf="!saving"
              style="flex: 1 1 0; min-width: 0;"
              [apiUrl]="apiUrl + '/availableSqlServers'"
              [params]="{sqlServerTypeId: sqlServerTypeId}"
              [(id)]="selectedConnectionId" [defaultOption]="selectedConnection"
              (objectChange)="selectedConnection = $event"
              placeholder="SQL Server Connection" [required]="false"
              [noMinWidth]="true"
              routerBase="sqls" [disabled]="loading || loadFailed || !sqlServerTypeId">
            </micro-select-pagination>
            <button mat-raised-button class="primary" type="button" (click)="link()"
                    style="flex: 0 0 auto; margin-left: auto; white-space: nowrap;"
                    [disabled]="!sqlServerTypeId || !selectedConnectionId || selectedConnection?.sqlServerTypeId !== sqlServerTypeId || saving || loading || loadFailed">
              <mat-icon>add_link</mat-icon> Add Connection
            </button>
          </div>
        </td>
      </tr>
      <tr><th>Name</th><th>Server Type</th><th>Connection Type</th><th>Host</th><th>Actions</th></tr>
      <tr *ngIf="loading"><td colspan="5"><em>Loading connections...</em></td></tr>
      <tr *ngIf="loadFailed"><td colspan="5">Unable to load connections. <button mat-button type="button" (click)="reload()">Retry</button></td></tr>
      <ng-container *ngIf="!loading && !loadFailed">
        <tr *ngFor="let connection of connections">
          <td><a routerLink="/sqls/{{connection.id}}">{{connection.name}}</a></td>
          <td>{{connection.sqlServerTypeId}}</td>
          <td>{{connection.connectionType}}</td>
          <td>{{connection.host}}</td>
          <td><button type="button" (click)="unlink(connection)" [disabled]="saving">Remove</button></td>
        </tr>
        <tr *ngIf="connections.length === 0"><td colspan="5"><em>No connections linked.</em></td></tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>
